<template>
    <a-modal
            title="消费券核销信息"
            :width="640"
            :visible="visible"
            @cancel="handleClose"
    >
        <a-table
                :columns="columns"
                :data-source="modalData"
                bordered>
            <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
            <template slot="action" slot-scope="text, record, index">
                <a-button type="link" :disabled="btnDisable"  @click="handleConfirmCoupon(record)">核销</a-button>
            </template>
        </a-table>
        <template slot="footer">
            <a-button key="submit" type="primary" @click="handleClose">
                确定
            </a-button>
        </template>
    </a-modal>
</template>

<script>
    import vendorAdmin from "../service/vendorAdmin";

    export default {
        name: "CouponPendingList",
        data () {
            return {
                // Modal统一数据
                modalData: [],
                visible: false,

                columns: [
                    {title: '#', width: "15%", scopedSlots: { customRender: 'serial' }},
                    {title: '消费券面值', width: "25%",dataIndex: 'couponValue',},
                    {title: '用户昵称',width: "35%", dataIndex: 'userNickname', },
                    {title: '操作',width: "25%", dataIndex: 'action', scopedSlots: {customRender: 'action'}}
                ],

                // 核销时禁止其他操作
                btnDisable: false,
                // 用于关闭“核销中”
                hide: null
            }
        },
        methods: {
            showModal(data) {
                this.modalData = data
                this.visible = true
            },
            handleClose () {
                this.visible = false
                this.hide()
                this.btnDisable = false
            },
            handleConfirmCoupon(item) {
                const h = this.$createElement
                let vm = this
                this.$confirm({
                    title: '请确认核销信息',
                    content: h('div', {}, [
                        h('p', '消费券面值: ' + item.couponValue),
                        h('p', '顾客昵称：' + item.userNickname),
                    ]),
                    okText: '确认',
                    cancelText: '取消',
                    onOk() {
                        vm.hide = vm.$message.loading('核销中', 0);
                        vm.btnDisable = true

                        vendorAdmin.confirmCoupon({id: item.id})
                        .then((value) => {
                            vm.hide()
                            vm.btnDisable = false

                            vm.$message.success("核销成功！")
                            let deleteIndex = -1
                            for(let i in vm.modalData) {
                                if(vm.modalData[i].id === item.id)
                                    deleteIndex = i
                            }
                            vm.modalData.splice(deleteIndex, 1)
                        }).catch((error)=>{
                            vm.hide()
                            vm.btnDisable = false
                        })
                    },
                });
            }
        }
    }
</script>

<style scoped>

</style>
